import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { faBars } from "@fortawesome/free-solid-svg-icons/faBars";
import Image from "../Atoms/Image";
import logo from "../../images/logo.png";
import LanguageSelector from "../Molecules/LanguageSelector";
import { useTranslation } from "react-i18next";
import ThemeButton from "../Atoms/ThemeButton";

interface HeaderProps {}

const Header: React.FC<HeaderProps> = () => {
  const [menu, setMenu] = useState(false);

  const { t } = useTranslation();

  const openMenu = () => {
    setMenu(!menu);
  };

  const closeMenu = () => {
    setMenu(false);
  };

  return (
    <header className="bg-gray-100 dark:bg-gray-900 sticky top-0 z-20 transition-colors duration-300">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
        <div className="flex w-full sm:w-3/12 items-center justify-between">
          <Link
            className="title-font font-bold text-green-500 md:mb-0 text-xl"
            to="/"
            onClick={closeMenu}
          >
            <Image
              className="object-cover object-center rounded w-[100px] h-[50px]"
              source={logo}
              alt="logo"
            />
          </Link>

          <div className="flex items-center gap-3">
            <div className="md:hidden flex items-center gap-2">
              <ThemeButton />
              <LanguageSelector />
            </div>

            <button
              className="text-black dark:text-white md:hidden block"
              onClick={openMenu}
            >
              <FontAwesomeIcon
                icon={faBars}
                size="2x"
                className="hover:text-gray-600 dark:hover:text-gray-200"
              />
            </button>
          </div>
        </div>

        <div className="flex md:mt-0 w-full sm:w-9/12 items-center">
          <nav
            className={`${
              menu ? "block" : "hidden"
            } absolute top-20 right-0 w-full bg-gray-100 dark:bg-gray-900 md:bg-transparent rounded md:relative md:top-auto md:right-auto md:flex md:items-center md:w-auto md:space-x-4`}
          >
            <Link
              to="projects"
              className="block md:inline-block px-4 py-2 text-center text-black dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
              onClick={closeMenu}
            >
              {t("nav.projects")}
            </Link>
            <hr />
            <Link
              to="skills"
              className="block md:inline-block px-4 py-2 text-center text-black dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
              onClick={closeMenu}
            >
              {t("nav.skills")}
            </Link>
            <hr />
            <Link
              to="testimonials"
              className="block md:inline-block px-4 py-2 text-center text-black dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
              onClick={closeMenu}
            >
              {t("nav.testimonials")}
            </Link>
            <hr />
            <Link
              to="contact"
              className="block md:inline-block px-4 py-2 text-center text-black dark:text-white hover:bg-gray-200 dark:hover:bg-gray-700"
              onClick={closeMenu}
            >
              {t("nav.contact")}
            </Link>
          </nav>

          <div className="hidden md:flex ml-auto">
            <ThemeButton />
            <LanguageSelector />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
